import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const FlowRadioGroup = ({ value, onChange}) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        value={value}
        onChange={onChange}
        name="flow"
      >
        <FormControlLabel value="in" control={<Radio />} label="In" />
        <FormControlLabel value="out" control={<Radio />} label="Out" />
      </RadioGroup>
    </FormControl>
  );
};

export default FlowRadioGroup;